// Footer.js
import React from 'react';

const AdminFooter = () => {
  return (
    <footer className="main-footer text-center footer-admin">
      <div className="float-right d-none d-sm-block">
          <b>Versión</b> 1.0 
        </div>
        <strong>
          &copy; 2023 <a href="https://chucherias-y-regalos.vercel.app/" className='link-footer'>Chucherias & Regalos</a>. | Todos los derechos
          reservados.
        </strong>
    </footer>
  );
};

export default AdminFooter;
